import React, { useEffect, useState } from "react";
import { Table, Form, Button, Container, Row, Col, Spinner } from "react-bootstrap";

const TransactionReport = () => {
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  // fetch laporan
  const fetchReports = async () => {
    setLoading(true);
    try {
      const response = await fetch("https://api.backofficemain.com/get_transaction_report.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          start_date: startDate,
          end_date: endDate,
        }),
      });

      const data = await response.json();
      if (data.success) {
        setReports(data.data);
      } else {
        console.error("Fetch error:", data.error);
      }
    } catch (error) {
      console.error("Network error:", error);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchReports();
  }, []);

  return (
    <Container className="mt-4">
      <h3 className="mb-4 fw-bold text-primary">Transaction Report</h3>

      {/* Filter Section */}
      <Row className="mb-4">
        <Col md={4}>
          <Form.Group>
            <Form.Label>Start Date</Form.Label>
            <Form.Control
              type="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
            />
          </Form.Group>
        </Col>
        <Col md={4}>
          <Form.Group>
            <Form.Label>End Date</Form.Label>
            <Form.Control
              type="date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
            />
          </Form.Group>
        </Col>
        <Col md={4} className="d-flex align-items-end">
          <Button variant="primary" className="w-100" onClick={fetchReports}>
            Filter
          </Button>
        </Col>
      </Row>

      {/* Table Section */}
      {loading ? (
        <div className="text-center my-5">
          <Spinner animation="border" variant="primary" />
        </div>
      ) : (
        <div className="table-responsive">
          <Table striped bordered hover className="align-middle">
            <thead className="table-dark">
              <tr>
                <th>Date</th>
                <th>Total Deposit</th>
                <th>Total Withdraw</th>
                <th>Total Bonus</th>
                <th>New Members</th>
              </tr>
            </thead>
            <tbody>
              {reports.length > 0 ? (
                reports.map((row, index) => (
                  <tr key={index}>
                    <td>{row.date}</td>
                    <td>${parseFloat(row.total_deposit || 0).toLocaleString()}</td>
                    <td>${parseFloat(row.total_withdraw || 0).toLocaleString()}</td>
                    <td>${parseFloat(row.total_bonus || 0).toLocaleString()}</td>
                    <td>{row.new_members}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={5} className="text-center">
                    No data available for selected dates
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      )}
    </Container>
  );
};

export default TransactionReport;
